import React from 'react';
import { MagnifyingGlassIcon, XCircleIcon } from '@heroicons/react/24/solid';

interface SearchFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const SearchFilter: React.FC<SearchFilterProps> = ({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
}) => {
  const clearSearch = () => {
    onChange('');
  };
  
  return (
    <div className={`relative ${className}`}>
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-500" />
      </div>
      <input
        type="text"
        className="block w-full pl-10 pr-10 py-2 border border-stake-border rounded-md leading-5 bg-dark-200 text-gray-300 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-stake-blue focus:border-stake-blue sm:text-sm transition-colors"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer" onClick={clearSearch}>
          <XCircleIcon className="h-5 w-5 text-gray-500 hover:text-stake-blue" />
        </div>
      )}
    </div>
  );
};

export default SearchFilter; 